(() => {
  if (window.hsbdPadCartPreviewStarted) return;
  window.hsbdPadCartPreviewStarted = true;
  const seen=new WeakSet(), libraries=new Map(), previews=new Map();
  let queue=Promise.resolve();
  async function paint(image) {
    try {
      const record=JSON.parse(image.dataset.hsbdPadPreview);
      const url=new URL(image.dataset.renderer,document.baseURI);
      if (url.origin !== location.origin) throw Error('Invalid renderer origin');
      if (!customElements.get('hsbd-pad-customizer')) await import(url.href);
      const libraryURL=image.dataset.library;
      if (!libraries.has(libraryURL)) libraries.set(libraryURL,fetch(libraryURL).then(r=>{if(!r.ok)throw Error('Pad library');return r.json();}));
      const key=libraryURL+'|'+image.dataset.hsbdPadPreview;
      if (!previews.has(key)) {
        const library=await libraries.get(libraryURL);
        const preview=await customElements.get('hsbd-pad-customizer').cartPreview(record,library,image.dataset.assets);
        previews.set(key,preview);
        if(previews.size>20)previews.delete(previews.keys().next().value);
      }
      const preview=previews.get(key);
      if (!image.isConnected) return;
      image.removeAttribute('srcset');image.src=preview.src;image.alt=preview.alt;
      image.width=preview.width;image.height=preview.height;image.dataset.hsbdPreviewReady='true';
    } catch (_) {
      // Keep the native product image if an old or incomplete record cannot render.
      image.dataset.hsbdPreviewReady='fallback';
    }
  }
  function scan() {
    document.querySelectorAll('img[data-hsbd-pad-preview]').forEach(image=>{
      if(seen.has(image))return;seen.add(image);
      queue=queue.then(()=>paint(image));
    });
  }
  new MutationObserver(scan).observe(document.body,{childList:true,subtree:true});
  scan();
})();
